export default __webpack_public_path__ + "static/media/favorite.aa70b6d2.svg";